/*!
 * Bootstrap v3.4.1 (https://getbootstrap.com/)
 * Copyright 2011-2019 Twitter, Inc.
 * Licensed under the MIT license
 */

if (typeof jQuery === 'undefined') {
  throw new Error('Bootstrap\'s JavaScript requires jQuery')
}

+function ($) {
  'use strict';
  var version = $.fn.jquery.split(' ')[0].split('.')
  if ((version[0] < 2 && version[1] < 9) || (version[0] == 1 && version[1] == 9 && version[2] < 1) || (version[0] > 3)) {
    throw new Error('Bootstrap\'s JavaScript requires jQuery version 1.9.1 or higher, but lower than version 4')
  }
}(jQuery);

import './bootstrap-v3/transition';
import './bootstrap-v3/alert';
import './bootstrap-v3/button';
import './bootstrap-v3/carousel';
import './bootstrap-v3/collapse';
import './bootstrap-v3/dropdown';
import './bootstrap-v3/modal';
import './bootstrap-v3/tooltip';
import './bootstrap-v3/popover';
import './bootstrap-v3/scrollspy';
import './bootstrap-v3/tab';
import './bootstrap-v3/affix';

/*!
 * ----------------------------------------
 * When an old V3 version is replaced...
 * remove from above and add to below
 * 
 * When a BS5 module is required...
 * you must have config and base-component (the first two)
 * ----------------------------------------
 */

//import '../../../../node_modules/bootstrap/js/src/util/config';
//import '../../../../node_modules/bootstrap/js/src/base-component';

//import '../../../../node_modules/bootstrap/js/src/alert';
//import '../../../../node_modules/bootstrap/js/src/button';
//import '../../../../node_modules/bootstrap/js/src/carousel';
//import '../../../../node_modules/bootstrap/js/src/collapse';
//import '../../../../node_modules/bootstrap/js/src/dropdown';
//import '../../../../node_modules/bootstrap/js/src/modal';
//import '../../../../node_modules/bootstrap/js/src/popover';
//import '../../../../node_modules/bootstrap/js/src/scrollspy';
//import '../../../../node_modules/bootstrap/js/src/tab';
//import '../../../../node_modules/bootstrap/js/src/toast';
//import '../../../../node_modules/bootstrap/js/src/tooltip';
